// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__R95CV","label":"SetPasswdForm_label__1Z3Gk"};